/* eslint-disable react/jsx-no-useless-fragment */
import { useState } from 'react';
import { Button, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';

interface RemoteConfigFields {
  cookbook_notification_id: number;
  cookbook_notification_img: string;
  cookbook_notification_content: string;
  cookbook_notification_close_btn_text: string;
  cookbook_notification_redirect_btn_text?: string;
  cookbook_notification_redirect_url_path?: string;
}

interface CookbookNotificationAlertProps {
  userId: number;
  cookbookNotificationData: RemoteConfigFields;
  getClosedNotificationsValues: () => Promise<void>;
  markNotificationAsClosed: (
    collectionName: string,
    userId: number,
    notificationId: number
  ) => Promise<void>;
}

const CookbookNotificationAlert: React.FC<CookbookNotificationAlertProps> = ({
  userId,
  cookbookNotificationData,
  markNotificationAsClosed,
}) => {
  const {
    cookbook_notification_id,
    cookbook_notification_img,
    cookbook_notification_content,
    cookbook_notification_close_btn_text,
    cookbook_notification_redirect_btn_text,
    cookbook_notification_redirect_url_path,
  } = cookbookNotificationData;

  const [isClosed, setIsClosed] = useState(false);

  const handleClose = async () => {
    setIsClosed(true);
    await markNotificationAsClosed('cookbook_notifications', userId, cookbook_notification_id);
  };

  return (
    <>
      {!isClosed ? (
        <Alert color="light" fade={false}>
          {Boolean(cookbook_notification_img) && (
            <div className="text-center">
              <img src={cookbook_notification_img} className="border-radius w-100" alt="" />
            </div>
          )}
          <p className={`small mb-l ${cookbook_notification_img ? 'mt-l' : ''}`}>
            {cookbook_notification_content}
          </p>
          <div className="text-center">
            <Button color="outline-secondary" size="sm" onClick={handleClose}>
              {cookbook_notification_close_btn_text}
            </Button>
            {Boolean(
              cookbook_notification_redirect_btn_text && cookbook_notification_redirect_url_path
            ) && (
              <Link
                to={
                  cookbook_notification_redirect_url_path
                    ? cookbook_notification_redirect_url_path
                    : '#'
                }
                onClick={handleClose}
              >
                <Button color="primary" size="sm" className="ms-l">
                  {cookbook_notification_redirect_btn_text}
                </Button>
              </Link>
            )}
          </div>
        </Alert>
      ) : null}
    </>
  );
};

export default CookbookNotificationAlert;
